import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import ContactGroupForm from "./ContactGroupForm";

function ContactGroup() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "contact-groups",
    id,
    { populate: ["contacts", "site"] }
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/contact-groups");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataContactGroup: any) => {
      const contactGroup = { ...dataContactGroup };

      try {
        if (contactGroup.id) {
          await updateItem(contactGroup.id, contactGroup);
        } else {
          await saveItem(contactGroup);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <ContactGroupForm onSubmit={onSubmit} contactGroup={item} />
  );
}

export default ContactGroup;
